export default __webpack_public_path__ + "static/media/brand-icons.31015e86.woff2";